<template>
  <div class="pluminput">
    <div class="pluminbtn min" type="button" @click="decrease">
      -
    </div>
    <div id="field">
      <input type="text" v-model="value" @keydown.enter="update" @blur="update">
    </div>
    <div class="pluminbtn plus" @click="increase">
      +
    </div>
  </div>
</template>

<script>
export default {
  props: {
    number: {
      default: 0,
      type: Number
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    }
  },
  data() {
    return {
      value: 0
    }
  },
  methods: {
    increase() {
      if (this.max === undefined || this.value < this.max) {
        this.value = parseInt(this.value) + 1;
        this.$emit('input', { source: 'ACTION', value: 1 })
      }
    },
    decrease() {
      if (this.min === undefined || this.value > this.min) {
        this.value = parseInt(this.value) - 1;
        this.$emit('input', { source: 'ACTION', value: -1 })
      }
    },
    update() {
      this.$emit('input', { source: 'INPUT', value: this.value });
    }
  },
  watch: {
    number: {
      handler(val) {
        this.value = val
      }
    }
  },
  created() {
    this.value = this.number
  }
}
</script>

<style lang="scss" scoped>
.pluminput {
  border: 1px solid silver;
  border-radius: 5px;
  background-color: #FFFFFF;
  margin: 0 5px 0 5px;
  display: inline-block;
  user-select: none;
}

.pluminput div {
  display: inline-block;
}

.pluminput #field input {
  width: 50px;
  text-align: center;
  padding: 3px;
  border: none;
  -webkit-appearance: none;
}

.pluminput .pluminbtn {
  padding: 3px 10px 3px 10px;
  cursor: pointer;
  border-radius: 5px;
}

.pluminput .pluminbtn:hover{
  background-color: #dddddd;
}

.pluminput .pluminbtn:active {
  background-color: #c5c5c5;
}
</style>
